module.exports = __webpack_public_path__ + "bc4a368fd1f81c095fc65b3cf205c4b2.png";


//////////////////
// WEBPACK FOOTER
// ./directives/appCard/discover.png
// module id = 926
// module chunks = 0